import {createAction, props} from '@ngrx/store';
import {IClient} from '../../../shared/interfaces/IClient';

export const getUser = createAction('[User] Get');
export const getUserSuccess = createAction(
  '[User] Get Success',
  props<{ user: IClient }>()
);
export const getUserError = createAction(
  '[User] Get Error',
  props<{ error: any }>()
);
export const setUserLogged = createAction(
  '[User] Logged',
  props<{ logged: boolean }>()
);
